// Auto-generated at build time in format YYMMDD.HHMM
// e.g., 250117.1430 = January 17, 2025 at 2:30 PM
export const APP_VERSION = __BUILD_VERSION__;
